module.exports = __webpack_public_path__ + "static/studio-banner-a52fed9e7feb9430e51e0444430a04e5.png";